define('extensions/knockoutExtenders/numeric',[
    'lib/knockout'
],function (ko) {
    "use strict";

    //original source: http://knockoutjs.com/documentation/extenders.html
    //Extends an observable (or computed observable) and rounds it to the number of decimal places determined by precision
    // obs.extend({numeric: 2}); will round to 2 decimal places
    // obs.extend({numeric: {precision: 2, min: 0, max: 10}}); will round to 2 decimal places, and constrain the value to be between 0 and 10

    //Supports an options object with the following parameters: (all optional)
    //    precision - number of decimals to round to
    //    max - maximum value of the observable
    //    min - minimal value of hte observable
    ko.extenders.numeric = function(target, options) {
        //create a writeable computed observable to intercept writes to our observable
        var precision, min, max;
        if(typeof options === "object") {
            precision = options.precision;
            min = ko.isObservable(options.min) ? options.min : ko.observable(options.min);
            max = ko.isObservable(options.max) ? options.max : ko.observable(options.max);
        } else {
            precision = options;
        }
        var result = ko.computed({
            read: target,  //always return the original observables value
            write: function(newValue) {
                var current = target(),
                    roundingMultiplier = Math.pow(10, precision),
                    newValueAsNum = isNaN(newValue) ? 0 : parseFloat(+newValue),
                    valueToWrite = newValueAsNum;
                if (precision || precision === 0) {
                    valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;
                }
                
                if (max !== undefined && typeof(max()) == 'number' && valueToWrite > max()) {
                    valueToWrite = max();
                }
                
                if (min !== undefined && typeof(min()) == 'number' && valueToWrite < min()) {
                    valueToWrite = min();
                }
                
                //only write if it changed
                if (valueToWrite !== current && !isNaN(newValue)) {
                    target(valueToWrite);
                    
                    if (!ko.isComputed(target)) {
                        target.valueHasMutated();
                    }
                }

                //if the rounded value is the same, but a different value was written, force a notification for the current field
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }

            }
        }).extend({ notify: 'always' });
     
        //initialize with current value to make sure it is rounded appropriately
        result(target());
     
        //return the new computed observable
        return result;
    };

});
